import React from 'react';
import { DwListWrapper, DwWrapper } from '../../../../ConversationGroup.styled';
import DwItem from './components/dwItem/DwItem';

const DwUsers = ({ dwSavedUsers, selectedTicket, loadData }) => {
	return (
		<DwWrapper>
			DW:{' '}
			<DwListWrapper>
				{dwSavedUsers.map((user) => (
					<DwItem
						loadData={loadData}
						selectedTicket={selectedTicket}
						user={user}
					/>
				))}
			</DwListWrapper>
		</DwWrapper>
	);
};

export default DwUsers;
